<!-- components/Survey/questions/MultiSelect.svelte -->
<script>
  import { createEventDispatcher, onMount } from 'svelte';

  // Props from parent
  export let options = [];
  export let minSelect = 0;
  export let currentValue = [];

  const dispatch = createEventDispatcher();

  // Track if items are ready to animate (only after first render)
  let isInitialRender = true;

  // Toggle option selection
  function toggleOption(optionId) {
    let newValue;
    if (currentValue.includes(optionId)) {
      newValue = currentValue.filter(id => id !== optionId);
    } else {
      newValue = [...currentValue, optionId];
    }

    dispatch('select', newValue);
  }

  // Continue button handler
  function handleContinue() {
    if (minSelect > 0 && currentValue.length < minSelect) return;
    dispatch('advance');
  }

  onMount(() => {
    setTimeout(() => {
      isInitialRender = false;
    }, 50);
  });
</script>

<div class="multi-select">
  <!-- Options -->
  <div class="options-container">
    {#each options as option}
      <div 
        class="option"
        class:selected={currentValue.includes(option.id)}
        on:click={() => toggleOption(option.id)}
        role="button"
        tabindex="0"
        on:keydown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleOption(option.id); }}
      >
        <div class="option-content">
          <div class="checkbox">
            {#if currentValue.includes(option.id)}
              <div class="check" class:no-animation={isInitialRender}>
                <svg viewBox="0 0 24 24" width="24" height="24">
                  <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"></path>
                </svg>
              </div>
            {/if}
          </div>
          <div class="label">{option.label}</div>
        </div>
      </div>
    {/each}
  </div>

  <!-- Continue Button -->
  <div class="action-container">
    
<button
      class="continue-button"
      class:active={currentValue.length > 0 && currentValue.length >= minSelect}
      on:click={handleContinue}
      disabled={currentValue.length < minSelect}
    >
      Continue
    </button>

    {#if minSelect > 0}
      <div class="selection-count">
        Selected: {currentValue.length} / {minSelect}+
      </div>
    {/if}
  </div>
</div>

<style>
  .multi-select {
    width: 100%;
  }

  .options-container {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
    margin-bottom: 2rem;
  }

  .option {
    padding: 1rem;
    border-radius: 8px;
    background-color: white;
    border: 2px solid #e0e0e0;
    cursor: pointer;
    transition: border-color 0.2s ease, background-color 0.2s ease, transform 0.2s ease, box-shadow 0.2s ease;
  }

  .option:hover {
    border-color: #FFB81C;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
  }

  .option.selected {
    border-color: #FFB81C;
    background-color: rgba(2, 0, 134, 0.05);
  }

  .option-content {
    display: flex;
    align-items: center;
  }

  .checkbox {
    width: 24px;
    height: 24px;
    border-radius: 4px;
    border: 2px solid #ccc;
    margin-right: 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: border-color 0.2s ease, background-color 0.2s ease;
  }

  .option.selected .checkbox {
    border-color: #FFB81C;
    background-color: #FFB81C;
  }

  .check {
    color: white;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .check:not(.no-animation) {
    animation: fade-in 0.2s ease;
  }

  @keyframes fade-in {
    from { opacity: 0; transform: scale(0.5); }
    to { opacity: 1; transform: scale(1); }
  }

  .check svg {
    fill: white;
  }

  .label {
    font-size: 1.1rem;
    color: #333;
    font-weight: 500;
  }

  .action-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1rem;
  }

  /* Continue Button */
  .continue-button {
  background-color: #cccccc; /* gray default */
  color: white;
  border: none;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  border-radius: 30px;
  cursor: not-allowed; /* gray default looks disabled */
  transition: background-color 0.2s ease;
  font-weight: 500;
}

.continue-button.active {
  background-color: #6F263D; /* solid red-ish when active */
  cursor: pointer;
}

.continue-button.active:hover {
  background-color: #8B3E50; /* slightly darker hover */
}

.continue-button:disabled:not(.active) {
  background-color: #cccccc;
  cursor: not-allowed;
}
  .selection-count {
    font-size: 0.9rem;
    color: #666;
  }

  @media (max-width: 768px) {
    .option {
      padding: 0.75rem;
    }

    .label {
      font-size: 1rem;
    }
  }
</style>